/**
 * Utility functions for display formatting and naming
 */

/**
 * Get display name for production capability (for UI display only)
 * Converts internal production capability names to user-friendly display names
 */
export const getDisplayName = (pcName: string): string => {
    // TODO: After peak @vistpand and @parmits will discuss how UI should look like, for now just use DDB values
    // if (pcName === 'Default_FC_PC') {
    //     return 'Default';
    // }
    // if (pcName === 'Default_Network_PC') {
    //     return 'Default Network';
    // }
    return pcName;
};